export default "__VITE_ASSET__BWgPd8JB__"